import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  section: css`
    display: flex;
    padding: 0px 16px 0px 16px;
    flex-direction: column;
  `,
  orgNameTitle: css`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  `,
  tagsContainer: css`
    display: flex;
    gap: 8px;
  `,
  divider: css`
    margin: 16px 0px 24px;
  `,
  infoContainer: css`
    padding-bottom: 24px;
    display: flex;
    gap: 16px;
  `,
  info: css`
    display: flex;
    align-items: center;
    color: ${colors.prussian};
  `,
  infoText: css`
    padding-left: 16px;
    text-decoration: none;
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  subheadingInfo: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
};

export default styles;
